import { Dialog, DialogTitle, DialogContent, Alert, DialogActions, Button, Box, Typography, Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import PropTypes from "prop-types";

StaffInfoModal.propTypes = {
  openModal: PropTypes.bool,
  onProceed: PropTypes.func,
  onClose: PropTypes.func,
  fieldAttributes: PropTypes.object,
  label: PropTypes.string,
  staffSubType: PropTypes.bool
}

export default function StaffInfoModal({ openModal, onProceed, onClose, fieldAttributes, label, staffSubType }) {
  const { getValues } = useFormContext(); 

  const fields = getValues(`${fieldAttributes?.fieldName}.staffMembers`);

  const Data = ({ field, value }) => <Grid container wrap="nowrap">
    <Grid item xs="auto">
      <Typography variant="body2" color="info.main">
        {field}:
      </Typography>
    </Grid>
    <Grid item xs sx={{ overflow: "hidden", ml: 0.5  }}>
      <Typography variant="body2" noWrap>
        {field === 'Staff type' ?
          fieldAttributes.options.find(x => x.value === String(getValues(value)))?.label : 
          getValues(value)}
      </Typography>
    </Grid>
  </Grid>

  return <Dialog disableEscapeKeyDown fullWidth maxWidth="sm" open={openModal}>
    <DialogTitle sx={{ textAlign: 'center' }}>
      <Box display="flex" alignItems="center" justifyContent="center" >
        <Typography variant="h4" color="info.main">
          {fieldAttributes?.questionTitle}
        </Typography>
      </Box>
      <Alert sx={{textAlign: 'left'}} severity="warning">
        Marking this position {label} will delete all data for this position.
      </Alert>
    </DialogTitle>
    <DialogContent sx={{ typography: 'body2' }}>
      {fields?.map((f, index) => 
        !f.deleteFlag && <Grid key={index} sx={{ pt: 1 }}>
          <Data field='First name' value={`${fieldAttributes?.fieldName}.staffMembers[${index}].firstName`} />
          <Data field='Last name' value={`${fieldAttributes?.fieldName}.staffMembers[${index}].lastName`} />
          <Data field='Cell phone' value={`${fieldAttributes?.fieldName}.staffMembers[${index}].cellPhone`} />
          <Data field='Email' value={`${fieldAttributes?.fieldName}.staffMembers[${index}].email`} />
          {staffSubType &&
            <Data field='Staff type' value={`${fieldAttributes?.fieldName}.staffMembers[${index}].staffSubTypeId`}/>}
        </Grid>
      )}
    </DialogContent>
    <DialogActions>
      <Button variant="outlined" color="primary" onClick={() => onClose()}>
        Cancel
      </Button>
      <Button
        color="primary"
        size="small"
        variant="contained"
        sx={{ mr: 1 }}
        onClick={() => onProceed()}
      >
        Proceed
      </Button>
    </DialogActions>
  </Dialog>
}